import { supabase } from '../supabaseClient';

async function getAllSales() {
    let query = supabase.from('Users').select('*', { count: 'exact' }).eq("isActive", true);
    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}

export { getAllSales }